'use strict';

var Joi = require('joi');
var authMethods = require('../utils/authMethods.js');

function _interopDefault (e) { return e && e.__esModule ? e : { 'default': e }; }

var Joi__default = /*#__PURE__*/_interopDefault(Joi);

var _Joi$string;
var GadgetAccountCreate = Joi__default["default"].object().keys({
  auth_method: (_Joi$string = Joi__default["default"].string()).valid.apply(_Joi$string, authMethods).required().description('The auth method used for signing up'),
  email: Joi__default["default"].string().email({
    tlds: {
      allow: false
    }
  }).required().allow(null).description('End user email')
}).description('This event is similar to gadget:user_login, with the exception that this only fires the first time the user ever authenticates.').meta({
  name: 'GadgetAccountCreate',
  filename: 'gadget:account_create.model'
});
var GadgetAccountCreate$1 = GadgetAccountCreate;

module.exports = GadgetAccountCreate$1;
//# sourceMappingURL=account_create.model.js.map
